/*global kakao*/
import React, { useEffect } from 'react'

const JcoupMap = () => {

  useEffect(() => {
    var container = document.getElementById('map1');
    var options = {
      center: new kakao.maps.LatLng(35.9009731, 128.581448),
      level: 1
    };

    var map1 = new kakao.maps.Map(container, options);
    var markerPosition = new kakao.maps.LatLng(35.9009731, 128.581448);
    var marker = new kakao.maps.Marker({
      position: markerPosition
    });
    marker.setMap(map1);

  }, [])


  return (
    <>
      <h3 style={{ textAlign: 'center', color: 'blue', backgroundColor: 'lightgray' }}>2공장:(주)제이콥 [접착(수지,캠록,FKM,몰리 등..)]</h3>
      <div>
        <div id="map1" style={{ width: "100%", height: "70vh" }}></div>
      </div>a
      &nbsp;
      <h5 style={{ textAlign: 'center' }}>주소 : 대구시 북구 침산동 67길69 (침산동)</h5>
    </>
  )
}


export default JcoupMap;